import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫画分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            八大类型分类，轻松找到你喜欢的韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-700`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 leading-relaxed hidden sm:block">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}